jQuery(document).ready(() => {
  $('.menu-item-has-children').each(function () {
    $(this).append('<span class="el-for-click"></span>');
  });

  $('#primaryNavBar ul li.dropdown > span').on('click', function () {
    $(this).closest('.dropdown').toggleClass('rotate');
    $(this).siblings('.dropdown-menu').toggleClass('show');
  });

  $(window).scroll(function() {
    if ($('header').hasClass('headroom--unpinned')) {
      $('#primaryNavBar').removeClass('show')
    }
  });
});


// WEBPACK FOOTER //
// ./scripts/modules/mobile-menu.js